import env from "../config/env";

const VERSION_KEY = "cwpos_app_version";
const SCHEMA_VERSION_KEY = "cwpos_schema_version";

// Bump this ONLY when a specific key's on-disk shape changes in a way old
// data can't satisfy (e.g. a required field added that existing tillData
// rows never wrote). Name exactly which keys break in SCHEMA_BREAKING_KEYS
// for that version — everything else is left untouched.
//
// This used to work the other way around: clearStaleData() deleted every
// localStorage key except an explicit "preserve" allowlist, on every app
// version bump. That fired on every deploy once build versioning started
// auto-deriving from git sha (previously dormant for months), and every
// time it fired, some key nobody had remembered to whitelist got wiped out
// from under an open till session: kds_device_id (BUG-1594, ee80d2bb),
// then posConfigStore/cartObj/transactionStore/... (POS-config-lost fix,
// d058ba89), then userData (this fix) — a recurring bug class, not a
// one-off, because "delete by default unless listed" fails silently the
// instant someone adds a new key anywhere in the app and doesn't know this
// file exists. Flipped to "keep by default unless named" so a forgotten
// key is safe instead of silently destructive.
const CURRENT_SCHEMA_VERSION = 1;
const SCHEMA_BREAKING_KEYS = [];

export function checkAppVersionGate() {
  try {
    const storedVersion = localStorage.getItem(VERSION_KEY);
    const currentVersion = env.releaseNo;

    if (!storedVersion) {
      localStorage.setItem(VERSION_KEY, currentVersion);
      return false;
    }

    if (storedVersion !== currentVersion) {
      // App-version bumps happen on every deploy (git-sha derived) and only
      // need to force a reload for fresh assets — they carry no information
      // about data shape, so they must not touch localStorage contents.
      localStorage.setItem(VERSION_KEY, currentVersion);
      return true;
    }

    return false;
  } catch {
    return false;
  }
}

export function checkSchemaVersionGate() {
  try {
    const stored = parseInt(localStorage.getItem(SCHEMA_VERSION_KEY), 10);
    if (stored === CURRENT_SCHEMA_VERSION) return false;

    SCHEMA_BREAKING_KEYS.forEach((key) => localStorage.removeItem(key));
    localStorage.setItem(SCHEMA_VERSION_KEY, String(CURRENT_SCHEMA_VERSION));
    return true;
  } catch {
    return false;
  }
}

export function stampCurrentVersion() {
  localStorage.setItem(VERSION_KEY, env.releaseNo);
  localStorage.setItem(SCHEMA_VERSION_KEY, String(CURRENT_SCHEMA_VERSION));
}
